import { useColorMode } from '@chakra-ui/react';

const GradientMageCircle = () => {
  return (
    <div className="relative w-[72px] h-[72px] rounded-full mt-[24px]">
      <div
        className="bg-gradient-multi-rainbox-lv2 absolute inset-[0px] rounded-full opacity-[0.92] z-[0] pointer-events-none"
        style={{
          filter: 'blur(12.19px)',
          WebkitFilter: 'blur(12.19px)',
          transform: 'translateZ(0)'
        }}
      />
      <div className="absolute inset-0 rounded-full overflow-hidden z-[1]">
        <img
          src="/assets/backgrounds/fan-buddy/Mage Light Skin Tone.png"
          alt="Mage Light Skin Tone"
          className="absolute top-[7px] right-[3px] w-full h-full object-cover z-[1]"
        />
        <BackgroundCircle />
      </div>
    </div>
  );
};

export default GradientMageCircle;

const BackgroundCircle = () => {
  const { colorMode } = useColorMode();
  const fillColor = colorMode === 'light' ? '#F6F6F6' : '#303030';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      aria-label="circle"
      role="img"
      className="absolute inset-0 z-[0] pointer-events-none"
    >
      <g filter="url(#filter0_i_366_5236)">
        <circle cx="36" cy="36" r="36" fill={fillColor} />
      </g>
      <defs>
        <filter
          id="filter0_i_366_5236"
          x="0"
          y="0"
          width="72"
          height="77.693"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="2.84651" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_366_5236" />
        </filter>
      </defs>
    </svg>
  );
};
